import React, { useEffect } from "react";
import Footer from "../Components/Header/Footer";
import Header from "../Components/Header/Header";

const Plans = () => {


  return (
    <div>

   
      <div className="pop-bg"></div>
  <Header/>
     
   
      {/* MOBILE MENU FULLY INCLUDED */}
      {/* USER DASHBOARD MENU INCLUDED */}
      {/* PRICING SECTION */}
      <section>
        <div className="plans-ban">
          <div className="container">
            <div className="row">
              <span className="pri">Pricing</span>
              <h1>Get Started <br /> Pick your Plan Now</h1>
              {/* <p>Lorem Ipsum is simply dummy text...</p> */}
              {/* <span className="nocre">No credit card required</span> */}
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="plans-main">
          <div className="container">
            <div className="row">
              <ul>

                {/* FREE PLAN */}
                <li>
                  <div className="pri-box">
                    <h2>Free</h2>
                    <p>Printer took a type...</p>
                    <a href="sign-up.html" className="cta">Get Started</a>
                    <span className="pri-cou"><b>₹0</b>/mo</span>
                    <ol>
                      <li><i className="fa fa-close close" /> 5 Premium Profiles view /mo</li>
                      <li><i className="fa fa-check" />Free user profile can view</li>
                      <li><i className="fa fa-close close" />View contact details</li>
                      <li><i className="fa fa-close close" />Send interest</li>
                      <li><i className="fa fa-close close" />Start Chat</li>
                    </ol>
                  </div>
                </li>

                {/* GOLD PLAN */}
                <li>
                  <div className="pri-box pri-box-pop">
                    <span className="pop-pln">Most popular plan</span>
                    <h2>Gold</h2>
                    <p>Printer took a type...</p>
                    <a href="sign-up.html" className="cta">Get Started</a>
                    <span className="pri-cou"><b>₹500</b>/year</span>
                    <ol>
                      <li><i className="fa fa-check" /> 20 Premium Profiles view /mo</li>
                      <li><i className="fa fa-check" />Free user profile can view</li>
                      <li><i className="fa fa-check" />View contact details</li>
                      <li><i className="fa fa-check" />Send interest</li>
                      <li><i className="fa fa-check" />Start Chat</li>
                    </ol>
                  </div>
                </li>

                {/* PLATINUM PLAN */}
                <li>
                  <div className="pri-box">
                    <h2>Platinum</h2>
                    <p>Printer took a type...</p>
                    <a href="sign-up.html" className="cta">Get Started</a>
                    <span className="pri-cou"><b>₹750</b>/Life time</span>
                    <ol>
                      <li><i className="fa fa-check" /> 50 Premium Profiles view /mo</li>
                      <li><i className="fa fa-check" />Free user profile can view</li>
                      <li><i className="fa fa-check" />View contact details</li>
                      <li><i className="fa fa-check" />Send interest</li>
                      <li><i className="fa fa-check" />Start Chat</li>
                    </ol>
                  </div>
                </li>

              </ul>
            </div>
          </div>
        </div>
      </section>



   <Footer/>

    </div>
  );
};

export default Plans;
